import { createFileRoute } from '@tanstack/react-router';
import { OtpForm } from '@/features/consumer/otp-form';
import { z } from 'zod';
import { useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute('/(consumer)/_auth-layout/otp')({
  component: OtpFormWrapper,
  validateSearch: z.object({
    email: z.email(),
  }),
});

function OtpFormWrapper() {
  const navigate = useNavigate();
  const handleSuccess = () => {
    navigate({ to: '/dashboard', reloadDocument: true });
  };
  return <OtpForm onSuccess={handleSuccess} />;
}
